import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[TableResponsive2]',
})
export class TableResponsive2Directive {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.actualizarTabla();
  }

  ngAfterViewInit(): void {
    this.actualizarTabla();
  }

  private actualizarTabla(): void {
    const anchoPantalla = window.innerWidth;
    if (anchoPantalla < 700) {
      console.log('ancoh de tabla es: ', anchoPantalla)
      this.renderer.addClass(this.el.nativeElement, 'tabla-responsive');

      const filas = this.el.nativeElement.querySelectorAll('tr');
      filas.forEach((fila: { querySelectorAll: (arg0: string) => any; }) => {
        const celdas = fila.querySelectorAll('td');
        celdas.forEach((celda: { innerHTML: any; }) => {
          const nuevaCelda = this.renderer.createElement('td');
          this.renderer.addClass(nuevaCelda, 'celda-agrupada');
          this.renderer.setProperty(nuevaCelda, 'innerHTML', celda.innerHTML);

          const nuevaFila = this.renderer.createElement('tr');
          this.renderer.appendChild(nuevaFila, nuevaCelda);
          this.renderer.appendChild(this.el.nativeElement, nuevaFila);
        });

        this.renderer.removeChild(this.el.nativeElement, fila);
      });
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'tabla-responsive');

      const celdasAgrupadas = this.el.nativeElement.querySelectorAll('.celda-agrupada');
      celdasAgrupadas.forEach((celdaAgrupada: any) => {
        const nuevaFila = this.renderer.createElement('tr');
        this.renderer.appendChild(nuevaFila, celdaAgrupada);
        this.renderer.appendChild(this.el.nativeElement, nuevaFila);
        this.renderer.removeChild(this.el.nativeElement, celdaAgrupada);
      });
    }
  }

}
